import React from 'react';
import { ThemeProvider } from './src/components/theme-provider';
import { loadGtag } from './src/util/gtag';

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

export const shouldUpdateScroll = (e) => {
  if (
    e.routerProps.location.hash === '' &&
    e.prevRouterProps?.location.pathname !== window.location.pathname
  ) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  return false;
};

export const onRouteUpdate = ({ location }) => {
  const cookiesAccepted = localStorage.getItem('gtag-consent');
  if (cookiesAccepted && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
    });
  }
};

export const onInitialClientRender = () => {
  const consent = localStorage.getItem('gtag-consent');

  if (consent) {
    loadGtag();

    window.gtag('event', 'page_view', {
      page_path: window.location.pathname + window.location.search,
    });
  }
};
